import axios from 'axios';  

const state = {
  // result: null,
  isHeatmap: null,
  isIDW: null,
  isR: null,
  isG: null,
  isB: null,
  isLog: null,
  isLoadingData: null,
  isDrawing: null,
  dateStart: null,
  dateEnd: null,
  completeDateStart: null,
  completeDateEnd: null,
  rMin: 0,
  rMax: 50,
  isRRange: null,
  maxD: 10,
  scale: 10,
  gMin: 0,
  gMax: 10,
  isGRange: null,
  bMin: 0,
  bMax: 50,
  isBRange: null,
  idwOpacity: 0.5,
  isCustomData: true,
  isFit: false,
  ptsNum: null,
  rFilterMin: null,
  rFilterMax: null,
  isRFilter: null,
  gFilterMin: null,
  gFilterMax: null,
  isGFilter: null,
  bFilterMin: null,
  bFilterMax: null,
  isBFilter: null,
  isServerSideCalc: true,
  isWaterMask: true,
  hmPointSize: 5,
  avgTime: 1,
  intervalTime: 5,
  // Значение поля "Laser, nm" (одно на все вкладки). Пустая строка — фильтр
  // по лазеру не применяется; сопоставление с ell_18_2_pos живёт на бэкенде.
  laser: '',
  calibrations: [],
  trackPoints: [],
  paramTitles: ['Measuring parameter 1', 'Measuring parameter 2', 'Measuring parameter 3']
};

const getters = {
  // stateResult: state => state.result,
  stateIsHeatmap: state => state.isHeatmap,
  stateIsIDW: state => state.isIDW,
  stateIsR: state => state.isR,
  stateIsG: state => state.isG,
  stateIsB: state => state.isB,
  stateIsLog: state => state.isLog,
  stateIsLoadingData: state => state.isLoadingData,
  stateIsDrawing: state => state.isDrawing,
  stateDateStart: state => state.dateStart,
  stateDateEnd: state => state.dateEnd,
  stateRMin: state => state.rMin,
  stateRMax: state => state.rMax,
  stateIsRRange: state => state.isRRange,
  stateMaxD: state => state.maxD,
  stateScale: state => state.scale,
  stateGMin: state => state.gMin,
  stateGMax: state => state.gMax,
  stateIsGRange: state => state.isGRange,
  stateBMin: state => state.bMin,
  stateBMax: state => state.bMax,
  stateIsBRange: state => state.isBRange,
  stateIdwOpacity: state => state.idwOpacity,
  stateIsCustomData: state => state.isCustomData,
  stateCompleteDateStart: state => state.completeDateStart,
  stateCompleteDateEnd: state => state.completeDateEnd,
  stateIsFit: state => state.isFit,
  statePtsNum: state => state.ptsNum,
  stateRFilterMin: state => state.rFilterMin,
  stateRFilterMax: state => state.rFilterMax,
  stateIsRFilter: state => state.isRFilter,
  stateGFilterMin: state => state.gFilterMin,
  stateGFilterMax: state => state.gFilterMax,
  stateIsGFilter: state => state.isGFilter,
  stateBFilterMin: state => state.bFilterMin,
  stateBFilterMax: state => state.bFilterMax,
  stateIsBFilter: state => state.isBFilter,
  stateIsServerSideCalc: state => state.isServerSideCalc,
  stateIsWaterMask: state => state.isWaterMask,
  stateHmPointSize: state => state.hmPointSize,
  stateAvgTime: state => state.avgTime,
  stateIntervalTime: state => state.intervalTime,
  stateLaser: state => state.laser,
  calibrationNames: state => state.calibrations.map(c => c.name),
  allCalibrations: state => state.calibrations,
  stateTrackPoints: state => state.trackPoints,
  paramTitles: state => state.paramTitles,
  paramTitle1: state => state.paramTitles[0],
  paramTitle2: state => state.paramTitles[1],
  paramTitle3: state => state.paramTitles[2]
};

const actions = {
  // async getResult({commit}, daterange) {
  //   let {data} = await axios.get(`result/${daterange}`);
  //   commit('setResultM', data);
  // },
  async setTimeRangeState({commit}, data) {
    // let {data} = await axios.get(`time_range`);
    commit('setTimeRange', data);
  },
  async setHeatmapState({commit}, flag) {
    commit('setIsHeatmap', flag);
  },
  async setIDWState({commit}, flag) {
    commit('setIsIDW', flag);
  },
  async setRState({commit}, flag) {
    commit('setIsR', flag);
  },
  async setRMinState({commit}, value) {
    commit('setRMin', value);
  },
  async setRMaxState({commit}, value) {
    commit('setRMax', value);
  },
  async setIsRRangeState({commit}, flag) {
    commit('setIsRRange', flag);
  },
  async setGMinState({commit}, value) {
    commit('setGMin', value);
  },
  async setGMaxState({commit}, value) {
    commit('setGMax', value);
  },
  async setIsGRangeState({commit}, flag) {
    commit('setIsGRange', flag);
  },
  async setBMinState({commit}, value) {
    commit('setBMin', value);
  },
  async setBMaxState({commit}, value) {
    commit('setBMax', value);
  },
  async setIsBRangeState({commit}, flag) {
    commit('setIsBRange', flag);
  },
  async setGState({commit}, flag) {
    commit('setIsG', flag);
  },
  async setBState({commit}, flag) {
    commit('setIsB', flag);
  },
  async setLogState({commit}, flag) {
    commit('setIsLog', flag);
  },
  async setLoadingDataState({commit}, flag) {
    commit('setIsLoadingData', flag);
  },
  async setDrawingState({commit}, flag) {
    commit('setIsDrawing', flag);
  },
  async setDateStartState({commit}, value) {
    commit('setDateStart', value);
  },
  async setDateEndState({commit}, value) {
    commit('setDateEnd', value);
  },
  async setMaxDState({commit}, value) {
    commit('setMaxD', value);
  },
  async setScaleState({commit}, value) {
    commit('setScale', value);
  },
  async setIdwOpacityState({commit}, value) {
    commit('setIdwOpacity', value);
  },
  async setIsCustomDataState({commit}, value) {
    commit('setIsCustomData', value);
  },
  async setIsFitState({commit}, flag) {
    commit('setIsFit', flag);
  },
  async setPtsNumState({commit}, value) {
    commit('setPtsNum', value);
  },
  async setRFilterMinState({commit}, value) {
    commit('setRFilterMin', value);
  },
  async setRFilterMaxState({commit}, value) {
    commit('setRFilterMax', value);
  },
  async setIsRFilterState({commit}, flag) {
    commit('setIsRFilter', flag);
  },
  async setGFilterMinState({commit}, value) {
    commit('setGFilterMin', value);
  },
  async setGFilterMaxState({commit}, value) {
    commit('setGFilterMax', value);
  },
  async setIsGFilterState({commit}, flag) {
    commit('setIsGFilter', flag);
  },
  async setBFilterMinState({commit}, value) {
    commit('setBFilterMin', value);
  },
  async setBFilterMaxState({commit}, value) {
    commit('setBFilterMax', value);
  },
  async setIsBFilterState({commit}, flag) {
    commit('setIsBFilter', flag);
  },
  async setIsServerSideCalcState({commit}, flag) {
    commit('setIsServerSideCalc', flag);
  },
  async setIsWaterMaskState({commit}, flag) {
    commit('setIsWaterMask', flag);
  },
  async setHmPointSizeState({commit}, value) {
    commit('setHmPointSize', value);
  },
  async setAvgTimeState({commit}, value) {
    commit('setAvgTime', value);
  },
  async setIntervalTimeState({commit}, value) {
    commit('setIntervalTime', value);
  },
  async setLaserState({commit}, value) {
    commit('setLaser', value);
  },
  // Калибровочные кривые хранятся на бэкенде в таблице calibration_curves
  // и применяются как полином y = a*x^3 + b*x^2 + c*x + d к результату
  // формулы Measuring parameter. Локальный localStorage больше не используется.
  async loadCalibrations({ commit }) {
    try {
      const response = await axios.get('/calibrations');
      commit('setCalibrations', response.data || []);
    } catch (error) {
      console.error('Failed to load calibrations:', error);
      commit('setCalibrations', []);
    }
  },
  async addCalibration({ commit }, calibration) {
    const response = await axios.post('/calibrations', calibration);
    commit('addCalibration', response.data);
    return response.data;
  },
  async updateCalibration({ commit }, calibration) {
    const response = await axios.put(`/calibrations/${calibration.id}`, calibration);
    commit('updateCalibration', response.data);
    return response.data;
  },
  async deleteCalibration({ commit }, id) {
    await axios.delete(`/calibrations/${id}`);
    commit('deleteCalibration', id);
  },
  async setTrackPointsState({ commit }, points) {
    commit('setTrackPoints', points);
  },
  async fetchTrackPoints({ commit, state }, { start_time, end_time, limit = 20000, tolerance = 0, raw = false }) {
    try {
      const params = { start_time, end_time, limit };
      if (tolerance !== null && tolerance !== undefined) {
        params.tolerance = tolerance;
      }
      // raw=true — бэкенд не чистит трек (без MAD-выбросов, детектора залипшего
      // GPS и упрощения), остаётся только фильтр по полигону.
      if (raw) params.raw = true;
      // Тип лазера: пустое значение не шлём — бэкенд тогда не фильтрует.
      if (state.laser) params.laser = state.laser;
      const response = await axios.get('/measurements/track', { params });
      commit('setTrackPoints', response.data.points);
    } catch (error) {
      console.error('Error fetching track points:', error);
      commit('setTrackPoints', []);
    }
  },
  updateParamTitle({ commit }, payload) {
    commit('SET_PARAM_TITLE', payload);
  },
  // Инкрементальное продление трека в live-режиме: тянем только участок от
  // времени последней точки трека до now и добавляем строго более новые точки,
  // чтобы не перезапрашивать весь диапазон и не плодить дубликаты.
  async appendTrackPoints({ commit, state }, { end_time, limit = 20000, tolerance = 0, raw = false } = {}) {
    const pts = state.trackPoints || [];
    if (!pts.length) return;
    const last = pts[pts.length - 1];
    if (!last || !last.time) return;
    const lastMs = new Date(last.time).getTime();
    try {
      const params = { start_time: last.time, end_time, limit };
      if (tolerance !== null && tolerance !== undefined) {
        params.tolerance = tolerance;
      }
      // raw=true — без чистки трека на бэкенде (см. fetchTrackPoints).
      if (raw) params.raw = true;
      if (state.laser) params.laser = state.laser;
      const response = await axios.get('/measurements/track', { params });
      const incoming = response.data.points || [];
      const fresh = incoming.filter(
        p => p.time && new Date(p.time).getTime() > lastMs
      );
      if (fresh.length) commit('appendTrackPoints', fresh);
    } catch (error) {
      console.error('Error appending track points:', error);
    }
  }
};

const mutations = {
  // setResultM(state, result){
  //   if(JSON.stringify(result) != JSON.stringify(state.result)) {
  //     state.result = result;
  //   }
  //   else
  //   {
  //     state.isLoadingData = false;
  //   }
  // },
  setTimeRange(state, data){
    if(JSON.stringify(data) != JSON.stringify(state.data)) {
      state.completeDateStart = data['start'];
      state.completeDateEnd = data['end'];
    }
  },
  setIsHeatmap(state, flag){
    state.isHeatmap = flag;
  },
  setIsIDW(state, flag){
    state.isIDW = flag;
  },
  setIsR(state, flag){
    state.isR = flag;
  },
  setRMin(state, value){
    state.rMin = value;
  },
  setRMax(state, flag){
    state.rMax = flag;
  },
  setIsRRange(state, flag){
    state.isRRange = flag;
  },
  setGMin(state, value){
    state.gMin = value;
  },
  setGMax(state, flag){
    state.gMax = flag;
  },
  setIsGRange(state, flag){
    state.isGRange = flag;
  },
  setBMin(state, value){
    state.bMin = value;
  },
  setBMax(state, flag){
    state.bMax = flag;
  },
  setIsBRange(state, flag){
    state.isBRange = flag;
  },
  setIsG(state, flag){
    state.isG = flag;
  },
  setIsB(state, flag){
    state.isB = flag;
  },
  setIsLog(state, flag){
    state.isLog = flag;
  },
  setIsLoadingData(state, flag){
    state.isLoadingData = flag;
  },
  setIsDrawing(state, flag){
    state.isDrawing = flag;
  },
  setDateStart(state, value){
    state.dateStart = value;
  },
  setDateEnd(state, value){
    state.dateEnd = value;
  },
  setMaxD(state, value){
    state.maxD = value;
  },
  setScale(state, value){
    state.scale = value;
  },
  setIdwOpacity(state, value){
    state.idwOpacity = value;
  },
  setIsCustomData(state, value){
    state.isCustomData = value;
  },
  setIsFit(state, flag){
    state.isFit = flag;
  },
  setPtsNum(state, value){
    state.ptsNum = value;
  },
  setRFilterMin(state, value){
    state.rFilterMin = value;
  },
  setRFilterMax(state, flag){
    state.rFilterMax = flag;
  },
  setIsRFilter(state, flag){
    state.isRFilter = flag;
  },
  setGFilterMin(state, value){
    state.gFilterMin = value;
  },
  setGFilterMax(state, flag){
    state.gFilterMax = flag;
  },
  setIsGFilter(state, flag){
    state.isGFilter = flag;
  },
  setBFilterMin(state, value){
    state.bFilterMin = value;
  },
  setBFilterMax(state, flag){
    state.bFilterMax = flag;
  },
  setIsBFilter(state, flag){
    state.isBFilter = flag;
  },
  setIsServerSideCalc(state, flag){
    state.isServerSideCalc = flag;
  },
  setIsWaterMask(state, flag){
    state.isWaterMask = flag;
  },
  setHmPointSize(state, value){
    state.hmPointSize = value;
  },
  setAvgTime(state, value){
    state.avgTime = value;
  },
  setIntervalTime(state, value){
    state.intervalTime = value;
  },
  setLaser(state, value){
    state.laser = value || '';
  },
  setCalibrations(state, calibrations) {
    state.calibrations = calibrations;
  },
  addCalibration(state, calibration) {
    state.calibrations = [...state.calibrations, calibration];
  },

  // Вместо splice используем map
  updateCalibration(state, updatedCalibration) {
    state.calibrations = state.calibrations.map(c => 
      c.id === updatedCalibration.id ? updatedCalibration : c
    );
  },

  // Вместо filter оставляем filter (он уже возвращает новый массив)
  deleteCalibration(state, id) {
    state.calibrations = state.calibrations.filter(c => c.id !== id);
  },
  setTrackPoints(state, points) {
    state.trackPoints = points;
  },
  appendTrackPoints(state, points) {
    // Новая ссылка на массив, чтобы watcher trackPoints в MapContainer сработал
    // и перестроил линию (единственная LineString — дешевле, чем per-feature).
    state.trackPoints = (state.trackPoints || []).concat(points);
  },
  SET_PARAM_TITLE(state, { index, title }) {
    state.paramTitles[index] = title;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};